import { render, staticRenderFns } from "./RegionFlag.vue?vue&type=template&id=e58819f4"
import script from "./RegionFlag.vue?vue&type=script&lang=js"
export * from "./RegionFlag.vue?vue&type=script&lang=js"
import style0 from "./RegionFlag.vue?vue&type=style&index=0&id=e58819f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports